import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

const Section = styled.section`
  padding: 96px 0 64px;
  @media (max-width: 768px) {
    padding: 64px 0 40px;
  }
`;

export const SectionHeading = styled.div`
  max-width: 620px;
  margin: 0 auto 42px;
  text-align: center;
  .subtitle {
    color: ${themeGet('colors.secondary')};
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  h2 {
    color: ${themeGet('colors.white')};
    font-size: 36px;
    font-weight: 800;
    line-height: 1.25;
    letter-spacing: -0.03em;
    @media (max-width: 600px) {
      font-size: 28px;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  align-items: start;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const FaqLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px 28px;
  margin-top: 28px;
`;

export const ViewAllLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  color: ${themeGet('colors.secondary')};
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  width: auto;
  justify-content: center;

  &:hover {
    color: ${themeGet('colors.white')};
  }

  &:focus-visible {
    outline: 3px solid ${themeGet('colors.focusRing')};
    outline-offset: 2px;
    border-radius: 8px;
  }
`;

export const FaqItem = styled.details`
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 14px;
  color: ${themeGet('colors.white')};
  background: rgba(255, 255, 255, 0.04);
  summary {
    min-height: 56px;
    padding: 15px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    cursor: pointer;
    list-style: none;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.4;
    &::-webkit-details-marker {
      display: none;
    }
    &:focus-visible {
      outline: 3px solid ${themeGet('colors.focusRing')};
      outline-offset: 2px;
      border-radius: 12px;
    }
    svg {
      flex: 0 0 auto;
      transition: transform 180ms ease;
    }
  }
  &[open] summary svg {
    transform: rotate(45deg);
  }
  .faq-answer {
    padding: 0 48px 16px 18px;
    p {
      margin: 0;
      color: ${themeGet('colors.textColorLight')};
      font-size: 15px;
      line-height: 1.7;
    }
  }
`;

export default Section;
